import { action, decorate, observable, reaction } from "mobx";
import dayjs from "../../utils/dateTimeHelpers";

/**
 * Currently, only Freeform Internal & Ad Hoc are supported for Custom Clipping.
 * By hiding the other ADHOC event types, we can ensure that the user
 * will only see ADHOC events that support clipping which will reduce user confusion and frustration.
 */
const INCLUDED_TYPE_NAMES = ["Freeform Internal", "Ad Hoc", "Freeform Ad Hoc"];

class AdhocMetadataStore {
  constructor(cerebroApi) {
    this.reset();

    this.cerebroApi = cerebroApi;

    this.cerebroTypes = [];
    this.cerebroEvents = [];
    this.date = dayjs()
      .startOf("day")
      .toDate();
    this.loadingEvents = false;

    this.loadCerebroTypes();

    reaction(
      () => this.cerebroTypes,
      () => this.loadCerebroEvents(),
    );

    reaction(
      () => this.date,
      () => this.loadCerebroEvents(),
    );
  }

  reset() {
    this.cerebroTypes = [];
    this.cerebroEvents = [];
    this.date = dayjs()
      .startOf("day")
      .toDate();
  }

  setDate(date) {
    if (date !== this.date) {
      this.cerebroEvents = [];
    }

    this.date = date;
  }

  async loadCerebroTypes() {
    return this.cerebroApi
      .getCerebroEventTypes()
      .then(
        (types) =>
          (this.cerebroTypes = types.filter((item) =>
            INCLUDED_TYPE_NAMES.includes(item.name),
          )),
      );
  }

  async loadCerebroEvents() {
    if (!this.date || !this.cerebroTypes || this.cerebroTypes.length === 0) {
      return;
    }
    this.loadingEvents = true;

    const utcDate = dayjs(this.date).utc();

    return this.cerebroApi
      .getCerebroEvents(
        utcDate.subtract(2, "day").format("YYYY-MM-DD"),
        utcDate.add(2, "day").format("YYYY-MM-DD"),
        this.cerebroTypes.map((item) => item.id),
      )
      .then((events) => {
        this.cerebroEvents = events
          .filter(
            (event) =>
              dayjs(this.date).diff(
                dayjs(event.programStartTime).format("YYYY-MM-DD"),
                "day",
                true,
              ) === 0,
          )
          .sort((a, b) => {
            const diff = dayjs(a.programStartTime).diff(
              dayjs(b.programStartTime),
            );

            if (diff < 0) {
              return -1;
            } else if (diff > 0) {
              return 1;
            } else {
              return 0;
            }
          });
      })
      .finally(() => {
        this.loadingEvents = false;
      });
  }
}

decorate(AdhocMetadataStore, {
  cerebroTypes: observable,
  date: observable,
  cerebroEvents: observable,
  loadingEvents: observable,
  setDate: action,
});

export default AdhocMetadataStore;



// WEBPACK FOOTER //
// ./src/stores/customClips/AdhocMetadataStore.js